<header
  class="header flex-container flex-full-row flex-align-center flex-justify-space-between">
  @if (showExitButton) {
    <htc-button-with-icon
      class="header-left flex-align-center"
      classes="btn btn-with-left-icon btn-exit"
      (btnClicked)="onExitClick()"
      [imagePath]="exitButtonIcon"
      [btnText]="exitButtonText"
      [enable]="!disableHeaderButtons"
      data-testid="htc-exit-btn"
      [clickType]="clickType"
      [clickDescriptor]="clickDescriptor">
    </htc-button-with-icon>
  }

  <div
    class="header-middle flex-container flex-col flex-align-center flex-auto">
    @if ((activityService.showHeaderTitle | async) ?? true) {
      <div class="header-title-container">
        @if (activityService.seriesName | async; as seriesName) {
          <h1
            class="header-middle-title block-center text-overflow-ellipsis"
            [class.pk2]="activityService.isPreK2ReadingActivity()"
            data-testid="htc-header-series-name"
            [title]="seriesName">
            {{ seriesName }}
          </h1>
        }
        @if ((activityService.seriesName | async) === '') {
          <h1
            class="header-middle-title block-center text-overflow-ellipsis"
            [class.pk2]="activityService.isPreK2ReadingActivity()"
            data-testid="htc-header-episode-title"
            [title]="activityService.episodeTitle | async">
            {{ activityService.episodeTitle | async }}
          </h1>
        }
        <div
          class="header-middle-subtitle block-center"
          [class.pk2]="activityService.isPreK2ReadingActivity()">
          <h2 class="block-center" data-testid="htc-header-skill-name">
            {{ activityService.skillName$ | async }}
          </h2>
        </div>
      </div>
    }
    @if (disableHeaderButtons) {
      <div class="header-toaster" data-testid="htc-header-toaster">
        <div class="toaster-content">
          <div class="ellipsis-loader">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="toaster-text">Saving progress. Please wait.</span>
        </div>
      </div>
    }
  </div>

  <div
    class="header-right flex-container flex-full-row flex-align-center flex-justify-end">
    @if (showRewards) {
      <htc-nav-stars
        class="header-right-rewards"
        [numStars]="(userService.stars$ | async) ?? 0"
        [starCountDuration]="1000"
        data-testid="htc-header-rewards">
      </htc-nav-stars>
    }

    <div class="header-right-avatar">
      <button
        id="open-profile-menu"
        class="nav-avatar focus-outline hover-special"
        type="button"
        [attr.aria-label]="'HEADER.PROFILE_SETTINGS_MENU' | translate"
        aria-controls="profilePopup"
        aria-haspopup="true"
        [attr.aria-expanded]="userMenuVisible"
        (click)="toggleUserMenu()"
        [disabled]="
          isEarlyAccess || !isAuthenticationEnabled || disableHeaderButtons
        "
        htcAudioClick
        [audioType]="clickType"
        [descriptor]="clickDescriptor"
        data-testid="htc-header-open-profile-button">
        <htc-avatar
          class="avatar"
          [avatar]="userService.avatar$ | async"
          [flair]="'circle'"
          maskStyle="masked">
        </htc-avatar>
      </button>
      @if (userMenuVisible) {
        <htc-profile-popup
          id="profilePopup"
          role="menu"
          [attr.aria-label]="'HEADER.PROFILE_SETTINGS' | translate"
          [name]="
            (userService.firstName$ | async) +
            ' ' +
            (userService.lastName$ | async | initial)
          "
          [avatar]="userService.avatar$ | async"
          [showProfile]="userMenuVisible"
          (showProfileChange)="toggleUserMenu()"
          [(supportMenu)]="showSupportMenu"
          [(settingsMenu)]="showSettingsMenu">
        </htc-profile-popup>
      }
    </div>
  </div>

  <htc-contact-support [(showPopup)]="showSupportMenu"></htc-contact-support>
  <htc-settings [(showPopup)]="showSettingsMenu"></htc-settings>
</header>
